import { FilterBuilder } from '../Types';

const priceEURBuilder: FilterBuilder = params => {
  const priceMinFilter = params.priceMin
    ? `priceEUR>=${Math.floor(params.priceMin / 100)}`
    : '';
  const priceMaxFilter = params.priceMax
    ? `priceEUR<=${Math.ceil(params.priceMax / 100)}`
    : '';

  return [priceMinFilter, priceMaxFilter].filter(Boolean).join(' AND ');
};

export default priceEURBuilder;
